// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host kendo-window {
  border: 1px solid #275cab;
  border-radius: 4px !important;
}

:host ::ng-deep kendo-window-titlebar,
:host ::ng-deep .k-dialog-titlebar,
:host ::ng-deep .k-window-titlebar {
  background-color: #51738b !important;
  padding: 0.25rem 0.5rem !important;
}

.read-only-notice {
  background-color: #fff3cd;
  border: 1px solid #ffeaa7;
  border-radius: 4px;
  padding: 8px 12px;
  margin-bottom: 10px;
  text-align: center;
}

.read-only-text {
  color: #856404;
  font-size: 14px;
  font-weight: 500;
}

.unused-accounts-footer {
  padding-bottom: 0;
  padding-left: 0;
  padding-right: 0;
}

.unused-accounts-book *::selection {
  background-color: #3390ff !important;
  color: white !important;
}

:host ::ng-deep .modal-body,
:host ::ng-deep .spread-container--unused-accounts {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
}

:host ::ng-deep .spread-container--unused-accounts {
  flex: 1 1 auto;
  min-height: 0;
  min-width: 0;
}

:host ::ng-deep gc-spread-sheets,
:host ::ng-deep .unused-accounts-book {
  width: 100% !important;
  height: 100% !important;
  min-height: 0;
  min-width: 0;
  display: block;
}

.spreadsheet--processing {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.processing-indicator {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 20px;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.processing-indicator .icon_spinner {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/model-structure/balance-sheet/unused-accounts/unused-accounts.component.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,6BAAA;AACF;;AAEA;;;EAGE,oCAAA;EACA,kCAAA;AACF;;AAEA;EACE,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;AACF;;AAEA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AACF;;AAEA;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;AACF;;AAGE;EACE,oCAAA;EACA,uBAAA;AAAJ;;AAIA;;EAEE,YAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;AADF;;AAIA;EACE,cAAA;EACA,aAAA;EACA,YAAA;AADF;;AAIA;;EAEE,sBAAA;EACA,uBAAA;EACA,aAAA;EACA,YAAA;EACA,cAAA;AADF;;AAIA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,0CAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AADF;;AAIA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,yCAAA;AADF;;AAIA;EACE,kCAAA;AADF;;AAIA;EACE;IACE,uBAAA;EADF;EAGA;IACE,yBAAA;EADF;AACF","sourcesContent":[":host kendo-window {\r\n  border: 1px solid #275cab;\r\n  border-radius: 4px !important;\r\n}\r\n\r\n:host ::ng-deep kendo-window-titlebar,\r\n:host ::ng-deep .k-dialog-titlebar,\r\n:host ::ng-deep .k-window-titlebar {\r\n  background-color: #51738b !important;\r\n  padding: 0.25rem 0.5rem !important;\r\n}\r\n\r\n.read-only-notice {\r\n  background-color: #fff3cd;\r\n  border: 1px solid #ffeaa7;\r\n  border-radius: 4px;\r\n  padding: 8px 12px;\r\n  margin-bottom: 10px;\r\n  text-align: center;\r\n}\r\n\r\n.read-only-text {\r\n  color: #856404;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n}\r\n\r\n.unused-accounts-footer {\r\n  padding-bottom: 0;\r\n  padding-left: 0;\r\n  padding-right: 0;\r\n}\r\n\r\n.unused-accounts-book {\r\n  *::selection {\r\n    background-color: #3390ff !important;\r\n    color: white !important;\r\n  }\r\n}\r\n\r\n:host ::ng-deep .modal-body,\r\n:host ::ng-deep .spread-container--unused-accounts {\r\n  height: 100%;\r\n  width: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n:host ::ng-deep .spread-container--unused-accounts {\r\n  flex: 1 1 auto;\r\n  min-height: 0;\r\n  min-width: 0;\r\n}\r\n\r\n:host ::ng-deep gc-spread-sheets,\r\n:host ::ng-deep .unused-accounts-book {\r\n  width: 100% !important;\r\n  height: 100% !important;\r\n  min-height: 0;\r\n  min-width: 0;\r\n  display: block;\r\n}\r\n\r\n.spreadsheet--processing {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background-color: rgba(255, 255, 255, 0.8);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 1000;\r\n}\r\n\r\n.processing-indicator {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 10px;\r\n  padding: 20px;\r\n  background-color: white;\r\n  border-radius: 8px;\r\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.processing-indicator .icon_spinner {\r\n  animation: spin 1s linear infinite;\r\n}\r\n\r\n@keyframes spin {\r\n  from {\r\n    transform: rotate(0deg);\r\n  }\r\n  to {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
